import * as React from 'react';

export const Finished = (): JSX.Element => {
    return <div className={'c-quickscan__alert c-quickscan__alert--info'}>Bedankt voor het insturen van uw gegevens. We nemen zo spoedig mogelijk contact met u op.</div>
}
